// ===== DEALER PAGE - NEW
// ================================================================================

var dealer_page = {
    settings: {
        required: $(".dealer-location-form"),
        regions: $(".dealer-location-form .dealer-region"),
        areas: $(".dealer-location-form .dealer-area"),
        autocomplete: $("#autocomplete"),
    },

    init: function () {
        if (this.settings.required.length) {
            this.checkValues();
            this.bindUIActions();
            this.setupAutocomplete();
        }
    },

    bindUIActions: function () {
        // On changing the Dealer Region
        dealer_page.settings.regions.on("change", dealer_page.updateAreas);
        // On changing the Dealer Area
        dealer_page.settings.areas.on("change", function () {
            // Get the IDs for Region and Area
            var region = dealer_page.settings.regions
                .find(":selected")
                .val();
            var area = dealer_page.settings.areas.find(":selected").val();
            // Set values for the query string
            var params = ["region=" + region, "area=" + area];
            // Reload the page with query string
            window.location.href = "?" + params.join("&");
        });
    },

    // Refresh page when an autocomlete item is selected
    checkAutocomplete: function (ui) {
        // Set values for the query string
        var params = ["region=" + ui.item.region, "area=" + ui.item.area];

        // Reload the page with query string
        window.location.href = "?" + params.join("&");
    },

    // If a Region is already selected (e.g. after reloading with a region
    // in the query string), activate and populate the Area field
    checkValues: function () {
        var region = dealer_page.settings.regions.find(":selected").val();
        if (region.length) {
            dealer_page.updateAreas();
        }
    },

    // Setup values for the autocomplete search feature
    setupAutocomplete: function () {
        var data = [];

        $(".hidden-area-options option[data-region]").each(function () {
            var values = {
                label: $(this).text().trim(),
                region: $(this).data("region"),
                area: parseInt($(this).val()),
            };

            data.push(values);
        });

        dealer_page.settings.autocomplete.autocomplete({
            source: data,
            select: function (event, ui) {
                dealer_page.checkAutocomplete(ui);
            },
        });
    },

    // Update Area dropdown menu based on Region selection
    updateAreas: function () {
        dealer_page.settings.areas.closest(".form-row").removeClass("disabled");

        var region_id = dealer_page.settings.regions.find(":selected").val();

        dealer_page.settings.areas.empty();

        // Use hidden-area-options as source to get all options
        $(".hidden-area-options option").each(function () {
            var dataRegion = $(this).data("region");

            // Append options matching the selected region, preserving
            // whether this option was the one selected on page load
            if (dataRegion && dataRegion.toString() === region_id) {
                var selected = $(this).is(":selected") ? " selected" : "";
                dealer_page.settings.areas.append('<option value="' + $(this).val() + '"' + selected + '>' + $(this).text() + '</option>');
            }
        });

        // Handle the case where no options match
        if (dealer_page.settings.areas.children("option").length === 1) {
            dealer_page.settings.areas.append('<option disabled>No areas available</option>');
        }

        // Rebuilding the options doesn't fire the events forms.js listens
        // for, so activate the label here based on the resulting value
        dealer_page.settings.areas
            .closest(".gfield")
            .toggleClass("has-value", !!dealer_page.settings.areas.val());
    },
    
};
dealer_page.init();